// extracted by mini-css-extract-plugin
export default {"section":"styles_section__TRa8p","wave":"styles_wave__Hn92f","animate":"styles_animate__CpmB7","content":"styles_content__vb13C"};